import * as swcHelpers from '@swc/helpers';
import * as React from 'react';
import { Provider } from 'react-redux';
import { useLocation, useFormatter } from '@grandvisionhq/frk-routing';
import { contextKey } from './Saga/routing.js';

var ReduxProvider = (_param)=>{
    var { store , children  } = _param, rest = swcHelpers.objectWithoutProperties(_param, [
        "store",
        "children"
    ]);
    const { replace , push  } = useLocation();
    const format = useFormatter();
    React.useEffect(()=>{
        const context = {
            replace,
            push,
            format
        };
        // Need to set the context on the store to expose it to _all_ sagas
        store.setSagaContext({
            [contextKey]: context
        });
    }, [
        store,
        format,
        replace,
        push
    ]);
    return /*#__PURE__*/ React.createElement(Provider, swcHelpers.extends({}, rest, {
        store: store
    }), children);
};

export { ReduxProvider };
//# sourceMappingURL=provider.js.map
